'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _reactRedux = require('react-redux');

var _homeSlide = require('assets/img/home/home-slide-1.jpg');

var _homeSlide2 = _interopRequireDefault(_homeSlide);

var _homeSlide3 = require('assets/img/home/home-slide-2.jpg');

var _homeSlide4 = _interopRequireDefault(_homeSlide3);

var _homeSlide5 = require('assets/img/home/home-slide-3.jpg');

var _homeSlide6 = _interopRequireDefault(_homeSlide5);

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slides = [_homeSlide2.default, _homeSlide4.default, _homeSlide6.default];

// import { Helper } from 'helpers/support';
var Home = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!setupActions.isSeoLoaded(getState())) {
      promises.push(dispatch(setupActions.loadSeo()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    seos: state.setup.seos
  };
}, {
  saveUserLocation: userActions.saveUserLocation
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      random: Math.floor(Math.random() * slides.length),
      showSearch: true
    }, _this.onScroll = function () {
      try {
        if (window.scrollY < 18 && !_this.state.showSearch || document.body.scrollTop < 18 && !_this.state.showSearch) {
          _this.setState({ showSearch: true });
        }
        if (window.scrollY > 18 && _this.state.showSearch || document.body.scrollTop > 18 && _this.state.showSearch) {
          _this.setState({ showSearch: false });
        }
      } catch (err) {
        console.log(err);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          _this2.props.saveUserLocation(position.coords);
        });
      }
      window.addEventListener('scroll', this.onScroll, false);
      document.body.addEventListener('scroll', this.onScroll, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, false);
      document.body.addEventListener('scroll', this.onScroll, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Home.scss');
      var showSearch = this.state.showSearch;

      var divStyle = {
        backgroundImage: 'url(' + slides[this.state.random] + ')'
      };
      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_components.HelmetSEO, { path: '/' }),
        _react2.default.createElement(
          'div',
          { id: 'welcomePage', className: styles.welcomePage },
          _react2.default.createElement(
            'div',
            { className: styles.homeSearch, style: divStyle },
            _react2.default.createElement(
              _reactBootstrap.Grid,
              null,
              _react2.default.createElement(
                _reactBootstrap.Row,
                null,
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { md: 8, mdOffset: 2 },
                  showSearch && _react2.default.createElement(_components.Search, { position: 'home', location: this.props.location })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.category },
            _react2.default.createElement(_components.Category, null)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_components.VoucherHorizontalList, null),
          _react2.default.createElement(_components.HomeServiceShopHorizontalList, null),
          _react2.default.createElement(_components.NearMeShopHorizontalList, null),
          _react2.default.createElement(_components.ProminentShopHorizontalList, null),
          _react2.default.createElement(_components.CollectionHorizontalList, null),
          _react2.default.createElement(_components.SuggestedShopHorizontalList, null),
          _react2.default.createElement(_components.BookingSupportHorizontalList, null)
        )
      );
    }
  }]);
  return Home;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  seos: _react.PropTypes.object,
  saveUserLocation: _react.PropTypes.func
}, _temp2)) || _class) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1675
// module chunks = 0